import {BankIcon} from '@/modules/foundation/components/icons/bank-icon';
import {BriefcaseIcon} from '@/modules/foundation/components/icons/briefcase-icon';
import {CarIcon} from '@/modules/foundation/components/icons/car-icon';
import {CardIcon} from '@/modules/foundation/components/icons/card-icon';
import {CollectionIcon} from '@/modules/foundation/components/icons/collection-icon';
import {CompassIcon} from '@/modules/foundation/components/icons/compass-icon';
import {ConstructionIcon} from '@/modules/foundation/components/icons/construction-icon';
import {DamageIcon} from '@/modules/foundation/components/icons/damage-icon';
import {EierskifteIcon} from '@/modules/foundation/components/icons/eierskifte-icon';
import {ElectricIcon} from '@/modules/foundation/components/icons/electric-icon';
import {FaqIcon} from '@/modules/foundation/components/icons/faq-icon';
import {HouseIcon} from '@/modules/foundation/components/icons/house-icon';
import {InfoCircleIcon} from '@/modules/foundation/components/icons/info-circle-icon';
import {InsuranceIcon} from '@/modules/foundation/components/icons/insurance-icon';
import {PersonIcon} from '@/modules/foundation/components/icons/person-icon';
import {SearchIcon} from '@/modules/foundation/components/icons/search-icon';
import {TravelIcon} from '@/modules/foundation/components/icons/travel-icon';
import {UserchatIcon} from '@/modules/foundation/components/icons/user-chat-icon';
import {cn} from '@/modules/foundation/shared/tailwind';

const _iconValues = [
	'none',
	'house',
	'electric',
	'construction',
	'card',
	'bank',
	'insurance',
	'damage',
	'eierskifte',
	'person',
	'collection',
	'car',
	'briefcase',
	'user-chat',
	'compass',
	'faq',
	'info',
	'search',
	'travel',
] as const;

export type FinknIcons = (typeof _iconValues)[number];

export const iconsOptionsList = [
	{title: 'Ingen', value: 'none'},
	{title: 'Hus', value: 'house'},
	{title: 'Personskade', value: 'electric'},
	{title: 'Yrkesskade', value: 'construction'},
	{title: 'Bankkort', value: 'card'},
	{title: 'Bank', value: 'bank'},
	{title: 'Forsikring', value: 'insurance'},
	{title: 'Skade', value: 'damage'},
	{title: 'Eierskifte', value: 'eierskifte'},
	{title: 'Personforsikring', value: 'person'},
	{title: 'Inkasso', value: 'collection'},
	{title: 'Motorvogn', value: 'car'},
	{title: 'Foretaksportalen', value: 'briefcase'},
	{title: 'Min sak', value: 'user-chat'},
	{title: 'Guide', value: 'compass'},
	{title: 'FAQ', value: 'faq'},
	{title: 'Info', value: 'info'},
	{title: 'Søk', value: 'search'},
	{title: 'Reise', value: 'travel'},
];

export const renderFinknIcon = (icon?: FinknIcons) => {
	switch (icon) {
		case 'house':
			return HouseIcon;
		case 'electric':
			return ElectricIcon;
		case 'construction':
			return ConstructionIcon;
		case 'card':
			return CardIcon;
		case 'none':
			return null;
		case 'bank':
			return BankIcon;
		case 'eierskifte':
			return EierskifteIcon;
		case 'person':
			return PersonIcon;
		case 'collection':
			return CollectionIcon;
		case 'car':
			return CarIcon;
		case 'insurance':
			return InsuranceIcon;
		case 'briefcase':
			return BriefcaseIcon;
		case 'user-chat':
			return UserchatIcon;
		case 'compass':
			return CompassIcon;
		case 'faq':
			return FaqIcon;
		case 'info':
			return InfoCircleIcon;
		case 'damage':
			return DamageIcon;
		case 'search':
			return SearchIcon;
		case 'travel':
			return TravelIcon;
		default:
			return null;
	}
};

/**
 * Parent element that has a hover effect on the icon need the `group` class
 * to be applied.
 */
export const HoverIcon = ({
	icon,
	className,
}: {
	icon?: FinknIcons;
	className?: string;
}) => {
	const Icon = icon ? renderFinknIcon(icon) : null;
	if (!Icon) {
		return null;
	}
	return (
		<span
			className={cn(
				[
					'text-error-35',
					'border-2',
					'border-error-35',
					'size-12',
					'rounded-full',
					'flex',
					'items-center',
					'justify-center',
					'text-2xl',
					'relative',
					'z-10',
					'overflow-hidden',
					'group-hover:bg-error-35',
					'group-hover:text-white',
					'transition-colors',
				],
				className,
			)}
		>
			{/* FIXME: fix react hooks eslint errors*/}
			{/* eslint-disable-next-line react-hooks/static-components */}
			<Icon aria-hidden className="relative z-10" />
		</span>
	);
};
